/* MARVI OCEAN - drifting motes in the water column.

   Appended to <body>, NOT to .st-page / .oj-page.

   The motes layer is position:fixed with inset:0, so it covers the whole
   viewport. Inside a page element that creates a stacking context, its
   negative z-index is trapped there and it paints over everything that
   follows in the document, including the footer. On the Ocean Journal the
   footer was rendering the whole time and was simply covered.

   On <body> the negative z-index resolves against the root stacking context,
   so the motes sit behind the content and behind the footer, where they
   belong.

   Purely decorative. Skipped entirely when reduced motion is requested. */
(function(){
'use strict';
function boot(){
  if(!document.querySelector('.st-page, .oj-page')) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if(document.querySelector('.st-motes')) return;

  var style = document.createElement('style');
  style.textContent =
    '.st-motes{position:fixed;inset:0;z-index:-1;pointer-events:none;opacity:.4;overflow:hidden}'+
    '.st-motes span{position:absolute;bottom:-12px;border-radius:50%;'+
    'background:radial-gradient(circle at 30% 30%,rgba(255,255,255,.55),rgba(150,205,220,.06));'+
    'animation:stRise linear infinite}'+
    '@keyframes stRise{0%{transform:translateY(0) translateX(0);opacity:0}'+
    '12%{opacity:.7}88%{opacity:.35}'+
    '100%{transform:translateY(-118vh) translateX(22px);opacity:0}}';
  document.head.appendChild(style);

  var box = document.createElement('div');
  box.className = 'st-motes';
  box.setAttribute('aria-hidden','true');

  for(var i=0;i<16;i++){
    var s = document.createElement('span');
    var size = 3 + Math.random()*8;
    s.style.left = (Math.random()*100)+'%';
    s.style.width = size+'px';
    s.style.height = size+'px';
    s.style.animationDuration = (13 + Math.random()*17)+'s';
    s.style.animationDelay = (-Math.random()*22)+'s';
    box.appendChild(s);
  }

  document.body.appendChild(box);
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
else boot();
})();
